import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Bus Reservation System" link="https://github.com/AdityaKumawat97/MERN-BUS-APP" bg="linear-gradient(to right bottom, #40b3ae, #0099bb, #007acc, #0055cd, #2e14aa);" mdxType="ProjectCard">
A Full stack Bus ticket booking application made using MERN Stack (MongoDB, Express js, React js, Node js), Token-based authentication implemented using Passport JS.
    </ProjectCard>
    <ProjectCard title="E-Commerce Application" link="https://github.com/AdityaKumawat97/react-e-commerce-website" bg="linear-gradient(to right bottom, #40b3ae, #0099bb, #007acc, #0055cd, #2e14aa);" mdxType="ProjectCard">
This application uses Firebase for authentication, Firestore which acts as the database, Stripe API. A full stack project based on MERN Stack
    </ProjectCard>
    <ProjectCard title="COVID Tracker" link="https://frosty-torvalds-c16af4.netlify.app/" bg="linear-gradient(to right bottom, #40b3ae, #0099bb, #007acc, #0055cd, #2e14aa);" mdxType="ProjectCard">
An application which showcases data related to COVID-19 in Cards also has a line graph for the global data and bar charts for individual countries.
    </ProjectCard>
    <ProjectCard title="Weather Application" link="https://github.com/AdityaKumawat97/weather-App" bg="linear-gradient(to right bottom, #40b3ae, #0099bb, #007acc, #0055cd, #2e14aa);" mdxType="ProjectCard">
A simple React JS based application, that displays the current weather based on the entered geolocation data.
    </ProjectCard>  
    <ProjectCard title="Static Restaurant Website" link="https://adityakumawat97.github.io/Restaurant-Website-Advanced-SASS/" bg="linear-gradient(to right bottom, #40b3ae, #0099bb, #007acc, #0055cd, #2e14aa);" mdxType="ProjectCard">
A website built with pure HTML and SASS.
    </ProjectCard>
    <ProjectCard title="Static Tour Website" link="https://ak-tours.netlify.app" bg="linear-gradient(to right bottom, #40b3ae, #0099bb, #007acc, #0055cd, #2e14aa);" mdxType="ProjectCard">
A website built with pure HTML and advanced styling with SASS.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      